import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableDataSource,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    DatatableComponent,
    TableAction, PaginatedResponse,
} from '@cas-hub/acabim-common-client';

import {ProjectGroup} from '../../../../_models/group.model';
import {GroupService} from '../../../../_services/group.service';
import {NGXLogger} from 'ngx-logger';
import {map, tap} from 'rxjs/operators';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'acabim-admin-groups-projects',
    templateUrl: './groups-projects.component.html'
})
export class GroupProjectComponent implements OnInit {

    public addProjectGroupModal = false;
    public editProjectGroupModal = false;

    @ViewChild('dataTable') public dataTable!: DatatableComponent;

    public dataSources: DataTableDataSource<any>[] = [];

    constructor(
        public readonly router: Router,
        private readonly logger: NGXLogger,
        protected readonly datePipe: DatePipe,
        private readonly groupService: GroupService
    ) {
    }

    ngOnInit(): void {
        this.dataSources.push(
            new ProjectGroupDataSource(
                (first, length, sortOrder, sortField, filters) =>
                {
                    return this.groupService.getProjectGroups(first, length, sortOrder, sortField, filters)
                        .pipe(map(item => item as PaginatedResponse<ProjectGroup>), map(data => ({
                            totalRecords: data.totalRecords,
                            data: data.data
                        })), tap(data => {
                            data.data.forEach(group => {
                                const newDate = new Date(group.lastModifiedDate);
                                group.lastModifiedDate = (this.datePipe.transform(newDate, 'dd MMMM yyyy') as string);
                            });
                        }));
                    },
                (tableName: string, error: Error) => {
                    this.logger.debug('[GroupProjectComponent] Error in retrieving data in table ' + tableName);
                    this.logger.error(error);
                },
                (tableName: string) => {
                    this.logger.debug('[GroupProjectComponent] Completed retrieving data in table ' + tableName);
                }, (action: TableAction) => {
                    if (action.id === 0) {
                        this.logger.debug('[GroupProjectComponent] At action 0');
                    } else if (action.id === 1) {
                        this.logger.debug('[GroupProjectComponent] At action 1');
                    }
                }
            )
        );
    }

    // ADD
    setAddProjectGroupModal(value: boolean): void {
        this.addProjectGroupModal = value;
    }

    onAddProjectGroup(): void {
        this.addProjectGroupModal = true;
    }

    onAddCompletion(completed: string) {
        this.addProjectGroupModal = false;
        if (completed === 'added') {
            this.setAddProjectGroupModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setAddProjectGroupModal(false);
        }
    }

    // EDIT
    setEditProjectGroupModal(value: boolean): void {
        this.editProjectGroupModal = value;
        this.dataSources[0].showDetails = value;
    }

    onEditCompletion(completed: string) {
        console.log(completed);
        this.editProjectGroupModal = false;
        if (completed === 'updated') {
            this.setEditProjectGroupModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setEditProjectGroupModal(false);
        }
    }

    getStatus(line: number): void {
        console.log('Line: ' + line);
        console.log('addProjectGroup status: ' + this.addProjectGroupModal);
        console.log('showDetails status: ' + this.editProjectGroupModal);
    }

} // end of component

export class ProjectGroupDataSource extends DataTableLazyLoadDataSource<ProjectGroup> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate'}
        ];

    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: false,
        searchPlaceHolder: 'Search project groups',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: false,
        hasDetailsButton: true,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        hasFilters: true,
        isExportEnabled: false,
        hasActions: true
    };

    readonly columnFilters: ColumnFilter[] = [];

    readonly actions: TableAction[] = [{name: 'Archive', id: 0}, {name: 'Group', id: 1}];

    onDataExpanded(value: ProjectGroup): void {
    }

    constructor(readonly refresher: DataTableLazyLoadRefresher<ProjectGroup>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(refresher, observableErrorListener, observableCompleteListener);
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

}
